<template>
  <zt-modal
    :active="isActiveModalInfo"
    title="Documento nuevo"
    @close="closeDialog"
    max-width="600px"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem' }"
          />
        </div>
        <div>
          <h2 class="text-zt-xl font-medium pb-4">
            {{
              $t(
                  'message.publishDocuments.configGenericPublish.modal.success'
              )
            }}
            <br>
            {{
              $t(
                  'message.publishDocuments.configGenericPublish.modal.publicNew'
              )
            }}
          </h2>
          <p class="text-zt-lg">
            {{
              $t(
                  'message.publishDocuments.configGenericPublish.modal.description'
              )
            }}
          </p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-center lg:justify-end items-center p-4"
      >
        <zt-button
          flat
          data-vs-button="close-dialog"
          class="mr-1 text-primary-200"
          @click="redirectTo"
        >
          {{
            $t(
                'message.publishDocuments.configGenericPublish.modal.leave'
            )
          }}
        </zt-button>

        <zt-button data-vs-button="go-detail" @click="closeDialog">
          {{
            $t(
                'message.publishDocuments.configGenericPublish.modal.publicOther'
            )
          }}
        </zt-button
        >
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'ModalNotificationUserConfirm',
  inject: ['publishDocument', 'setActiveConfirmModal', 'clearPublish'],
  props: {
    isActiveModalInfo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.setActiveConfirmModal(false)
      this.clearPublish()
    },
    redirectTo() {
      this.closeDialog()
      this.$router.push({ name: 'MainDocumentPage' })
    }
  }
}
</script>

<style scoped>
.warning-icon {
  color: #fb8c00;
}
.warning-icon i {
  font-size: 4rem;
}
.zt-modal-footer {
  background-color: #eee;
}
::v-deep .zt-button.text-primary-200 {
  color: #4f41a3 !important;
  background-color: #eee;
}
::v-deep .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
</style>
